export const OFFER_MIN = 3
export const OFFER_DEFAULT = 12
export const OFFER_STEP = 1

export const GAMEPLAY_UPLOAD_STEPS = {
  HOW_TO: "how to",
  UPLOAD_GAMEPLAY: "upload gameplay",
  ENTER_DETAILS: "enter details",
  CONFIRM_REQUEST: "confirm request",
  REQUEST_RECEIVED: "request received",
}

export const ASSUMED_GAMEPLAY_DURATION = 30 * 60 // 30 Minutes
export const GAMEPLAY_FULFILLMENT_TIER_RATE_THRESHOLDS = [10, 30, 60]

export const GAMEPLAY_ATTACHMENT_TYPES = {
  FILE_ATTACHMENT: "attachment",
  REPLAY_REFERENCE: "replay",
  UNKNOWN: "unknown",
}

export const GAMEPLAY_ANALYSIS_REQUEST_STATES = {
  REQUESTED: "requested",
  VALIDATING: "validating",
  AUTHORIZING: "authorizing",
  ENQUEUED: "enqueued",
  LABORING: "laboring",
  APPEALED: "appealed",
  COMPLETED: "completed",
  REJECTED: "rejected",
  CLOSED: "closed",
}



// WEBPACK FOOTER //
// ./src/store/coaching/gameplay-analysis/gameplay-analysis.constants.js